import { styled } from 'theme/defaultTheme';

export const Wrapper = styled.div`
  min-height: calc(100vh - 110px);
  display: flex;
  width: 100%;
  max-width: 1600px;
  overflow: hidden;
`;
